document.addEventListener(
  "click",
  async function (event) {
    const userAgent = navigator.userAgent;
    const isMobileApp = userAgent.includes("XFPAPP") || userAgent.includes("ShopifyCheckoutSDK");
    const checkoutBtn = event.target.closest('[data-event-source="checkout"]');
    if (checkoutBtn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: { is_mobile_app: isMobileApp ? "true" : "false" },
          }),
        });
      } catch (error) {
        console.error("Failed to update cart:", error);
      } finally {
        window.location.href = "/checkout?skip_shop_pay=true";
      }
    }
    const addToBagBtn = event.target.closest("button.fp-following-add-to-bag");
    if (addToBagBtn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const parentForm = addToBagBtn.closest("form");
      if (parentForm) {
        parentForm.addEventListener("submit", (e) => e.preventDefault(), { once: true });
      }
      const parentAnchor = addToBagBtn.closest("a");
      if (parentAnchor) {
        parentAnchor.removeAttribute("href");
        parentAnchor.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
          },
          { once: true },
        );
      }
      const variantId = addToBagBtn.closest("div")?.querySelector('input[name="id"]')?.value;
      const productId = addToBagBtn.getAttribute("data-product-id");
      const productUrl = addToBagBtn.getAttribute("data-product-url");
      if (!variantId) return;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        const sectionsRes = await fetch("/cart?sections=cart-drawer,cart-icon-bubble,cart-drawer-items");
        const parsedState = await sectionsRes.json();
        // Add to swym queue.
        if (variantId && productId && productUrl) {
          processAddingItem({
            epi: variantId,
            empi: productId,
            du: productUrl,
            qty: 1,
          });
        }

        window.dispatchEvent(new Event("refresh-cart-drawer"));
        addToBagBtn.classList.add("disabled");
        addToBagBtn.setAttribute("disabled", "true");
        addToBagBtn.innerText = "Added to Bag";
        cartItems.push(variantId);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "quick-add",
          cartData: parsedState,
        });
      } catch (err) {
        console.error("Add to cart failed:", err);
      }
      return;
    }
  },
  { capture: true },
);

function renderInjectedProductCard(product, onClick, algoliaData, html = null) {
  const useHTML = typeof html === "function";
  const wrap = (strings, ...values) =>
    useHTML ? html(strings, ...values) : strings.reduce((acc, str, i) => acc + str + (values[i] ?? ""), "");
  const badgesConfig = window.badgeConfig;
  const badgeColorScheme = badgesConfig.color_schemes;
  const comingSoonBadgeHTML = wrap`<span class="badge price__badge-hold-status color-${badgeColorScheme.hold_status}">Coming soon</span>`;
  const soldOutBadgeHTML = wrap`<span class="badge price__badge-sold-out color-${badgeColorScheme.sold_out}">Sold Out</span>`;
  const callToEnquireBadgeHTML = wrap`<span
    class="fp-badge-retail-active badge price__badge-hold-status color-${badgeColorScheme.hold_status}"
    data-product-handle="${product.handle}"
  >Call to Enquire</span>`;
  const badges = {
    comingSoon: comingSoonBadgeHTML,
    soldOut: soldOutBadgeHTML,
    callToEnquire: callToEnquireBadgeHTML,
  };

  const currentUrl = window.location.href;
  const isFollowingPage = currentUrl.includes("following");
  const isProductSoldOut = product?.inventory_quantity < 1;
  const customMeta = algoliaData?.meta?.custom;
  const holdStatus = customMeta?.hold_status || "None";
  const isProductHoldStatusRetailValue = holdStatus?.toLowerCase() === "retail active";
  const isProductHoldStatusComingSoon = holdStatus?.toLowerCase() === "coming soon";
  const hasHoldStatus = holdStatus && holdStatus !== "None";
  const cartItems = window.cartItems || [];
  const isInCart = cartItems.includes(product.variant);
  const isLoggedIn = window.isLoggedIn;
  let badgeToDisplay = "";

  if (isProductHoldStatusRetailValue) {
    badgeToDisplay = badges.callToEnquire;
  } else if (isProductHoldStatusComingSoon) {
    badgeToDisplay = badges.comingSoon;
  } else if (isProductSoldOut) {
    badgeToDisplay = badges.soldOut;
  }

  const findAnotherButton = wrap`<div class="fp-following-add-to-bag-btn-wrapper">
    <a href="/search?q=${product.title}"
      title="Search for ${product.title}"
      class="button button--full-width fp-following-add-to-bag fp-find-another-button"
    >Find Another</a>
  </div>`;

  const addToBagButton = wrap`<div class="fp-following-add-to-bag-btn-wrapper">
    <form method="post" action="/cart/add" id="fp-following-add-to-bag-${product.variant}">
      <input type="hidden" name="id" value="${product.variant}" />
      <button
        aria-label="Add to Bag"
        type="submit"
        data-variant-id="${product.variant}"
        data-product-id="${product.id}"
        data-product-url="${product.url}"
        ${hasHoldStatus ? "disabled" : ""}
        class="button button--full-width fp-following-add-to-bag ${hasHoldStatus ? "disabled" : ""}"
      >Add to Bag</button>
    </form>
  </div>`;

  const productInBagWarning = wrap`<div class="fp-following-add-to-bag-btn-wrapper">
    <button
      aria-label="Added to Bag"
      type="submit"
      disabled
      class="button button--full-width fp-following-add-to-bag disabled"
    >
      Added to Bag
    </button>
  </div>`;

  const wishlistButton = useHTML
    ? isFollowingPage
      ? wrap`<div class="fp-follow-buttons-wrapper">
          <input
            id="product-card-edit--${product.id}"
            class="fp-following-checkbox"
            type="checkbox"
            name="select product"
            data-product-id="${product.id}"
            data-variant-id="${product.variant}"
            data-product-url="${product.url}"
          />
          <div class="fp-follow-icon-button">
            <span
              aria-label="Add to Wishlist"
              name="add-to-wishlist"
              data-product-name="${product.title}"
              data-with-epi="true"
              class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded"
              data-swaction="addToWishlist"
              data-product-id="${product.id}"
              data-variant-id="${product.variant}"
              data-product-url="${product.url}"
            >
              <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
            </span>
          </div>
        </div>`
      : wrap`<div class="fp-follow-icon-button">
          <span
            aria-label="Add to Wishlist"
            name="add-to-wishlist"
            data-product-name="${product.title}"
            data-with-epi="true"
            class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded"
            data-swaction="addToWishlist"
            data-product-id="${product.id}"
            data-variant-id="${product.variant}"
            data-product-url="${product.url}"
            ${!isLoggedIn ? "data-no-user" : ""}
          >
            <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
          </span>
        </div>`
    : isFollowingPage
      ? `<div class="fp-follow-buttons-wrapper">
        <input
          id="product-card-edit--${product.id}"
          class="fp-following-checkbox"
          type="checkbox"
          name="select product"
          data-product-id="${product.id}"
          data-variant-id="${product.variant}"
          data-product-url="${product.url}"
        />
        <div class="fp-follow-icon-button">
          <span
            aria-label="Add to Wishlist"
            name="add-to-wishlist"
            data-product-name="${product.title}"
            data-with-epi="true"
            class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded"
            data-swaction="addToWishlist"
            data-product-id="${product.id}"
            data-variant-id="${product.variant}"
            data-product-url="${product.url}"
          >
            <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
          </span>
        </div>
      </div>`
      : `<div class="fp-follow-icon-button">
        <span
          aria-label="Add to Wishlist"
          name="add-to-wishlist"
          data-product-name="${product.title}"
          data-with-epi="true"
          class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded"
          data-swaction="addToWishlist"
          data-product-id="${product.id}"
          data-variant-id="${product.variant}"
          data-product-url="${product.url}"
          ${!isLoggedIn ? "data-no-user" : ""}
        >
          <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
        </span>
      </div>`;

  return wrap`
    <div class="card-wrapper product-card-wrapper${isFollowingPage ? " fp-following-card" : ""}" id="${product.id}">
      ${wishlistButton}
      <div
        class="fp-algolia-product-card ais-hit ais-product card card--standard card--media"
        data-algolia-index="${algoliaData?.index ?? ""}"
        data-algolia-position="${algoliaData?.productPosition ?? ""}"
        data-algolia-queryid="${algoliaData?.queryID ?? ""}"
        data-algolia-objectid="${algoliaData?.objectID ?? ""}"
        data-handle="${algoliaData?.handle ?? ""}"
        data-variant-id="${algoliaData?.objectID ?? ""}"
        data-distinct="${algoliaData?._distinct ?? ""}"
        data-product-id="${algoliaData?.id ?? ""}"
        onClick="${onClick}"
      >
        <div class="fp-image-badge-wrapper">
          <span title="View ${product.title}" class="fp-image-wrapper">
            <img class="ais-hit--picture fp-injected-primary-image"
              src="${
                product.image && product.image !== "http://cdn.shopify.com/s/images/admin/no-image-compact.gif"
                  ? product.image
                  : "https://cdn.shopify.com/s/files/1/0894/3186/7695/files/content-placeholder-image.svg"
              }"
              alt="${product.alt}" />
            <img class="ais-hit--picture fp-injected-secondary-image"
              src="${
                product?.images?.[1] ??
                "https://cdn.shopify.com/s/files/1/0894/3186/7695/files/content-placeholder-image.svg"
              }"
              data-product-handle=${product.handle}
              alt="${product.alt}" />
          </span>
          <div class="fp-injected-badges ${badgesConfig.position}">${badgeToDisplay}</div>
        </div>

        <div class="card__content underline-links-hover">
          <div class="ais-hit--details card__information">
            <h3 class="ais-hit--title fp-title card__heading">
              <p class="fp-card__vendor h6">${product.vendor}</p>
              <a
                data-algolia-index="${algoliaData?.index ?? ""}"
                data-algolia-position="${algoliaData?.productPosition ?? ""}"
                data-algolia-queryid="${algoliaData?.queryID ?? ""}"
                data-algolia-objectid="${algoliaData?.objectID ?? ""}"
                href="${product.url}"
                class="full-unstyled-link fp-card__link"
              >
                <p class="fp-card__link__product-name fp-font-weight--regular">${product.title}</p>
              </a>
            </h3>
            <div class="card__information">
              ${
                product.condition
                  ? wrap`<p class="fp-condition left fp-font-weight--medium">${product.condition}</p>`
                  : ""
              }
            </div>
            ${
              isProductSoldOut || isProductHoldStatusRetailValue || isProductHoldStatusComingSoon
                ? ""
                : wrap`<div class="price price--on-sale">
                  <div class="price__container">
                    <div class="price__sale">
                      ${
                        product.compare_at_price > product.price
                          ? wrap`<span><s class="price-item body-md price-item--regular">
                          ${"$" + product.compare_at_price.toLocaleString("en-US")}</s></span>`
                          : ""
                      }
                      <span class="price-item body-md price-item--sale price-item--last">
                        ${"$" + product.price.toLocaleString("en-US")}
                      </span>
                      <span class="price-item body-md price-item--percent-off">
                        ${
                          product.compare_at_price > product.price
                            ? Math.round(
                                ((product.compare_at_price - product.price) / product.compare_at_price) * 100,
                              ) + "%"
                            : ""
                        }
                      </span>
                    </div>
                  </div>
                </div>`
            }
          </div>
        </div>
        ${
          isFollowingPage
            ? isProductSoldOut || hasHoldStatus
              ? findAnotherButton
              : isInCart
                ? productInBagWarning
                : addToBagButton
            : ""
        }
      </div>
    </div>
  `;
}
